import React from 'react';
import { Quote } from 'lucide-react';

const FounderApproach = () => {
  return (
    <section className="py-20 bg-slate-950 relative overflow-hidden">
      <div className="absolute inset-0">
        <div className="absolute w-[400px] h-[400px] bg-cyan-500/5 rounded-full blur-3xl top-1/2 left-1/4 animate-pulse"></div>
        <div className="absolute w-[400px] h-[400px] bg-teal-500/5 rounded-full blur-3xl top-1/2 right-1/4 animate-pulse" style={{ animationDelay: '1s' }}></div>
      </div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="bg-slate-800/30 backdrop-blur-sm border border-slate-700/50 rounded-3xl p-12">
          <div className="flex justify-center mb-6">
            <div className="w-16 h-16 bg-gradient-to-br from-cyan-500 to-teal-500 rounded-2xl flex items-center justify-center">
              <Quote className="w-8 h-8 text-white" />
            </div>
          </div>

          <h2 className="text-3xl md:text-4xl font-bold text-center text-white mb-8">
            Arkasındaki Yaklaşım
          </h2>

          <p className="text-lg text-gray-300 leading-relaxed text-center mb-8">
            RUYAN'ın stratejik yaklaşımı, 2009'dan bu yana SEO, performans, kullanıcı deneyimi ve yapay zekâ alanlarında aktif olarak çalışan bir bakış açısı tarafından şekillendirilmiştir.
          </p>

          <div className="text-center">
            <p className="text-gray-400 text-sm">
              Tolga Yürükakan
            </p>
            <p className="text-gray-500 text-xs mt-1">
              Kurucu
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FounderApproach;
